import React, { useCallback, useState } from 'react';
import { getTranslatedText, TICKET_SOURCE, useIntl } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage } from 'react-intl';
import {
  Link,
  Button,
  Badge,
  DisplayText,
  Collapsible,
  TextStyle
} from '@superops/ui-design-system';
import styled from 'styled-components';
import ClosureFields from '../../Components/Ticket/ClosureFields';

const TicketClosure = (props) => {
  const {
    ticket,
    fields,
    updateFields,
    showDuplicateButton,
    onDuplicate,
    disableDuplicate,
    key: uniqueTicketId,
    updateAllFields
  } = props;

  const intl = useIntl();

  const getSourceIcon = () => {
    let icon = null;
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(TICKET_SOURCE)) {
      if (value === ticket?.source) {
        icon = key;
      }
    }
    return icon;
  };

  const sourceIcon = getSourceIcon() || 'InlineError';

  const [isOpen, setIsOpen] = useState(true);

  const onFieldChange = useCallback((field, value) => {
    updateFields(ticket?.ticketId, field, value);
  });

  const NA = getTranslatedText(intl, 'app.noData.message') || 'NA';

  return (
    <>
      <div className="card-border br10">
        <div className="flex fx-sb actr p20">
          <div className="ticket-head-wrapper">
            <div className="flex actr g10 mb-15">
              <div>
                <Badge
                  status="critical"
                  icon={<SVGIcon name={sourceIcon} />}
                  iconPosition="left"
                >
                  <DisplayText size="medium">{`#${ticket?.displayId}`}</DisplayText>
                </Badge>
              </div>
              <div className="f11">
                {ticket?.subject ? (
                  <>
                    <Link removeUnderline>{ticket?.subject}</Link>
                  </>
                ) : (
                  <>
                    <TextStyle disabled>{NA}</TextStyle>
                  </>
                )}
              </div>
            </div>
            <div className="flex actr g20">
              <div className="flex actr g10">
                <SVGIcon name="ClientLogo" />
                <DisplayText size="medium">
                  {ticket?.client?.name || NA}
                </DisplayText>
              </div>
              <div className="flex actr g10">
                <SVGIcon name="Site" />
                <DisplayText size="medium">
                  {ticket?.site?.name || NA}
                </DisplayText>
              </div>
            </div>
          </div>
          <div className="flex actr g5">
            {showDuplicateButton && (
              <div className="duplicate-btn">
                <Button onClick={onDuplicate} disabled={disableDuplicate}>
                  <FormattedMessage id="ticket.bulkclose.duplicate.btn" />
                </Button>
              </div>
            )}
            <Button
              plain
              monochrome
              onClick={() => setIsOpen((prev) => !prev)}
              icon={
                isOpen ? (
                  <SVGIcon name="ArrowDown" color="#000" />
                ) : (
                  <SVGIcon name="ArrowRight" color="#000" />
                )
              }
            />
          </div>
        </div>

        <Collapsible open={isOpen} id={uniqueTicketId}>
          <div className="border-top p20">
            <ClosureFields
              fields={fields}
              onChange={onFieldChange}
              updateAllFields={updateAllFields}
              ticket={ticket}
              isBulkSection
            />
          </div>
        </Collapsible>
      </div>
    </>
  );
};

export default React.memo(TicketClosure);
